import { AppDispatch, RootState } from '..';
import { getPickupPointsSuccess, isPickupPointsLoading } from '../reducers';

import { REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { headers } from '.';
import { notification } from '../../utils';

export const fetchPickupPoints = () => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(isPickupPointsLoading(true));

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const { data } = await axios.get(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/pickup-points/company/${company?.company_id}`, headers(token));

    const { pickup_points, message } = data;

    try {
        
        dispatch(getPickupPointsSuccess(pickup_points));

    } catch (error: any) {
        console.log(message || error.message);

    }
    finally {
        dispatch(isPickupPointsLoading(false));
    }

};

export const addPickupPoint = (values: any) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/pickup-point/add`, { ...values, company_id: company?.company_id}, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchPickupPoints());
        
    } catch (error) {

        const { message }: any = error;
        notification('error', message);
        
    }
};

export const updatePickupPoint = (values: any) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/pickup-point/update`, {...values}, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchPickupPoints());
        
    } catch (error: any) {

        notification('error', message);
        console.log('Pickup point edit error: ', error.message);
        
    }
};

export const deletePickupPoint = (pickup_point_id: string) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.delete(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/pickup-point/${pickup_point_id}/delete`, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchPickupPoints());
        
    } catch (error: any) {

        notification('error', message);
        
    }
};